module.exports = __webpack_public_path__ + "media/images/area-badges/regenerative-ecosystems-d15a1cabe47d20ecf34709a4d30fdf6a.svg";